// import { Box, Button, Typography, Modal, Grid } from "@mui/material";

import React, { useEffect, useRef, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  Container,
  Grid,
  Box,
  Stack,
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Modal,
  DialogTitle,
  Tabs,
  Tab,
  Switch,
  FormGroup,
} from "@mui/material";

import {
  addEmployee,
  getNewSubscriptionReachageDetails,
  updateEmployee,
} from "./appoinmentDashboardApi";
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import { payloadDateFormat, swalAlertPopProps } from "../../utils/commonUtils";
import { getDataRechageDetail } from "./smbAccountRechargeCustomApiHandler";
import { getMonthDifference } from "./smbAccounrReachargeDateFunction";
import CloseIcon from "@mui/icons-material/Close";
import { getAlldetailSerice } from "../services/servicesListApi";

// import "./test.css";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { bookApoinment } from "./asppoinmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { routePath } from "../../constants/routePath";
import { setSession } from "../../utils/commonUtils";
import { setCustomerAppointmentId } from "../../app/store/reducer";
// import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { validationPersonalInfo } from "../payment/validation";
import Swal from "sweetalert2";
import ImageUploader from "../../common/imageUpload";
import { TextFieldSearch } from "../../common/fieldText";
import PoprchModal from "../payment/popSearch";
import { ModalHeader } from "../../common/modalHeader";
import { BorderTop } from "@mui/icons-material";
// import { getAlldetailSerice } from "../services/servicesListApi";
import html2pdf from "html2pdf.js";
import SelectedEmpPDFView from "../shareEmployeeProfile/selectedEmpPDFView";
dayjs.extend(utc);
dayjs.extend(timezone);

export default function FormModalShareMessageProfile({
  open,
  setOpen,
  modalData,
  getAll,
}) {
  const [pagination, setPagination] = useState({ page: 1, total: 10 });
  const [subscription, setSubscription] = useState();
  const [value, setValue] = React.useState("personalInfo");
  const [searchModal, setSearchModal] = useState(false);
  const [cardValue, setCardValue] = useState(null);

  const handleChange_Tab = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };

  const onClose = () => {
    setOpen(false);
  };
  const [search, setSearchvalue] = useState("");

  const struct = {
    billerId: "",
    employeeId: "",
    employeeName: "",
    alternateMobileNumber: "",
    customerName: "",
    mobileNumber: "",
    designation: "",
    pan: "",
    address: "",
    email: "",
    aadhar: "",

    paymentPercentage: 0,
    // otp: "",
    mailId: "",
    gender: "",
    bankName: "",
    bankAccountNumber: "",
    bankBranch: "",
    service: "",
    salary: 0,
    deduction: 0,
    date: "",
    ifsc: "",
    hour: "",
    minute: "",
    isActive: false,
  };
  const appnType = useSelector((state) => state.reducer.apppoinmentUerType);
  const dispatch = useDispatch();
  const info = useSelector((state) => state.reducer.detail);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    console.log("formData date  ", formData);

  }, [formData]);
  const [dateValue, setDateValue] = useState();
  const [dateValuet, setDateValuet] = useState();

  const [timeValue, setTimeValue] = useState(dayjs());
  const [otpEnabled, setOtpEnabled] = useState(true);

 const pdfRef = useRef();
   const userDetail = useSelector((state) => state.reducer.userDetail);
  const handleChange = (e) => {
    const { name, value } = e.target;
    const regex = /^[a-zA-Z\s]*$/;
    // console.log()
    // if (name == "employeeName"  ) {
    //   setFormData({
    //     ...formData,
    //     [name]: value[0],
    //   });
    // } else if (typeof value == "object") {
    //   setFormData({
    //     ...formData,
    //     [name]: value[0],
    //   });
    // } else {
    //   setFormData({
    //     ...formData,
    //     [name]: value,
    //   });
    // }
  };

  const setDate = (newValue) => {
    setDateValue(newValue);

    // const date = dayjs(newValue).tz('UTC').format('YYYY-MM-DDTHH:mm:ss.SSZ');

    // console.log("date ",date)

    const date = dayjs(newValue).tz("UTC").format("YYYY-MM-DDTHH:mm:ss");

    console.log("date", date);

    // console.log("data ",date)
    setFormData((prev) => {
      return { ...prev, doj: date };
      // return {...prev,date:date}
    });
  };

  const setDatet = (newValue) => {
    setDateValuet(newValue);

    // const date = dayjs(newValue).tz('UTC').format('YYYY-MM-DDTHH:mm:ss.SSZ');

    // console.log("date ",date)

    const date = dayjs(newValue).tz("UTC").format("YYYY-MM-DDTHH:mm:ss");

    console.log("date", date);

    // console.log("data ",date)
    setFormData((prev) => {
      return { ...prev, dob: date };
      // return {...prev,date:date}
    });
  };

  const setTime = (newValue) => {
    setFormData((prev) => {
      if (newValue["$H"] == 20) {
        prev.hour = newValue["$H"] + 12;
      } else {
        prev.hour = newValue["$H"];
      }
      prev.minute = newValue["$m"];
      return { ...prev };
    });
    setTimeValue(newValue);
  };

  const handleTagsChange = (e) => {
    const { value } = e.target;

    console.log("val8e ", value);
    setFormData({
      ...formData,
      service: value,
    });
  };

  const gender = (e) => {
    setFormData((prev) => {
      let temp = { ...prev };
      if (e.target) {
        temp.gender = e.target.value;
      } else {
        temp.gender = e;
      }
      return { ...temp };
    });
  };
  const [tabVale, setTabValue] = useState("salary");
  const tabFn = (e) => {
    setTabValue(e.target.value);
  };
  const handleVerifymobileNumber = () => {
    if (formData.mobileNumber) {
      setOtpEnabled(true);
    }
  };

  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();

    const formDataobj = new FormData();

    // map frontend keys to API schema
    const payload = {
      Id: formData?.id ?? 0,
      Name: formData?.employeeName || "",
      Address: formData?.address || "",
      Mobile: formData?.mobileNumber || "",
      PaymentPercentage: formData?.paymentPercentage ? parseFloat(formData?.paymentPercentage) : 0,
      IsActive: !!formData?.isActive,
      AlternateMobile: formData?.alternateMobileNumber || "",
      Gender: formData?.gender || "",
      Email: formData?.email || "",
      PAN: formData?.pan || "",
      Salary: formData?.salary ? parseFloat(formData?.salary) : 0,
      DOJ: formData?.doj ? dayjs(formData?.doj).format("YYYY-MM-DDTHH:mm:ss") : null,
      DOB: formData?.dob ? dayjs(formData?.dob).format("YYYY-MM-DDTHH:mm:ss") : null,
      Designation: formData?.designation || "",
      EmployeeId: formData?.employeeId || "",
      Aadhar: formData?.aadhar || "",
      Deduction: formData?.deduction ? parseFloat(formData?.deduction) : 0,
      BankName: formData?.bankName || "",
      BankAccountNumber: formData?.bankAccountNumber || "",
      BankBranch: formData?.bankBranch || "",
      IFSC: formData?.ifsc || "",
      Grade: formData?.grade || "",
      Specialization: formData?.specialization || "",
      Achievements: formData?.achievements || "",
      SkillSet: formData?.skillSet || "",
      Overview: formData?.overview || "",
      SalaryorPercentage: !!formData?.salaryorPercentage,
    };

    // Append to FormData
    Object.entries(payload).forEach(([key, value]) => {
      formDataobj.append(key, value ?? "");
    });

    // handle File separately
    if (formData?.File) {
      formDataobj.append("File", formData.File, formData.File.name);
    }

    if (!formData?.id) {
      addEmployee(formDataobj, () => {
        // setOpen(false);
        getAll();
      });
    } else {
      updateEmployee(formDataobj, () => {
        // setOpen(false);
        getAll();
      });
    }
  };

  const handlePDFExport = async () => {
    const element = pdfRef.current;
    const generateFileName = () => {
      const now = new Date();

      const day = now.getDate().toString().padStart(2, "0");
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const month = monthNames[now.getMonth()];
      const year = now.getFullYear();

      let hours = now.getHours();
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");

      const isPM = hours >= 12;
      const ampm = isPM ? "pm" : "am";
      hours = hours % 12 || 12; // convert to 12-hour format
      const hourStr = hours.toString().padStart(2, "0");

      return `${formData?.employeeName || "Employee"}_Profile_${day}-${month}-${year}_${hourStr}-${minutes}-${seconds}_${ampm}.pdf`;

    };

    const fileName = generateFileName();
    const opt = {
      margin: 0.5,
      fileName,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    try {
      const pdfBlob = await html2pdf().from(element).set(opt).output("blob");

      const file = new File([pdfBlob], fileName, {
        type: "application/pdf",
      });

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          title: "Selected Items",
          text: "Here is the selected item list from Palace The Salon",
          files: [file],
        });
      } else {
        const url = URL.createObjectURL(pdfBlob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "selected-items.pdf";
        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.error("PDF Share Error:", err);
    }
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const [servicesArr, setservicesArr] = useState([
    {
      serviceName: "Shaving",
      rate: "100.00/Per Head",
    },
    {
      serviceName: "Hair cutting",
      rate: "150.00/Per Head",
    },
  ]);
  const [validationMsgFlag, setValidationMsgFlag] = useState(null);

  const names = [
    "Haircut",
    "Hair Coloring",
    "Hair Styling",
    "Manicure",
    "Pedicure",
    "Facial",
    "Waxing",
    "Massage",
    "Makeup",
    "Bridal Makeup",
    "Threading",
    "Hair Spa",
    "Nail Art",
    "Skin Treatment",
  ];
  useEffect(() => {
    setFormData({
      ...formData,
      billerId: info.billerId,
    });
    setDate(timeValue);
    setTime(timeValue);
    gender("male");
  }, []);

  const infoD = useSelector((state) => state.reducer.detail);
  useEffect(() => {
    // getAlldetailSerice(
    //   {
    //     billerId: infoD?.billerId,
    //   },
    //   (res) => {
    //     console.log("Data res", res);
    //     setservicesArr(res?.data);
    //   }
    // );
  }, []);
  useEffect(() => {
    if (open === true && modalData) {
      console.log("modalData", modalData?.employeeName);
      setFormData({
        ...formData,

        id: modalData?.id,
        bankName: modalData?.bankName,
        bankAccountNumber: modalData?.bankAccountNumber,
        bankBranch: modalData?.bankBranch,
        employeeId: modalData?.employeeId,
        employeeName: modalData?.name,
        alternateMobileNumber: modalData?.alternateMobile,
        // customerName:modalData?.customerName,
        mobileNumber: modalData?.mobile,
        designation: modalData?.designation,
        pan: modalData?.pan,
        salary: modalData?.salary ?? 0,
        ifsc: modalData?.ifsc,
        address: modalData?.address,
        paymentPercentage: modalData?.paymentPercentage
          ? String(modalData?.paymentPercentage)
          : "0",
        // otp: "",
        dob: modalData?.dob,
        doj: modalData?.doj,
        deduction: modalData?.deduction ?? 0,
        email: modalData?.email,
        aadhar: modalData?.aadhar,
        gender: modalData?.gender,
        grade: modalData?.grade,
        service: "",

        date: "",
        hour: "",
        minute: "",
        isActive: modalData?.isActive,
        salaryorPercentage: modalData.salaryorPercentage ? true : false,

        specialization: modalData?.specialization || "",
        achievements: modalData?.achievements || "",
        skillSet: modalData?.skillSet || "",
        overview: modalData?.overview || "",
      });
      setSearchvalue({ name: modalData?.name, id: modalData?.id })
      setDateValue(dayjs(modalData?.dob));
      setDateValuet(dayjs(modalData?.doj));

      // setDateValuet()
      // getDataRechageDetail(getNewSubscriptionReachageDetails, setSubscription);
    } else {
      console.log("close");
      if (!validationMsgFlag) {
        setFormData({ ...struct });
      }
    }
  }, [open]);


  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "10%",

          left: { xs: "2%", sm: "25%", md: "25%", lg: "30%", xl: "35%" },

          // transform: "translate(-50%, -50%)",
          width: { xs: "95%", sm: "60%", md: "50%", lg: "40%", xl: "30%" },

          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          overflowY: "auto",
        }}
      >
        <ModalHeader
          title={"Share Employee Profile"}
          onClose={() => {
            setOpen(false);
          }}
        />

        <Box sx={{ padding: "20px" }} display="flex" justifyContent="center">
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={2}
              sx={{ height: "60vh", paddingRight: "10px", overflow: "auto" }}
            >
              <React.Fragment>
                <Grid item xs={12}>
                  <Grid xs={12} item>
                    <TextFieldSearch
                      label={"Employee Name"}
                      search={search?.name}
                      setOpen={setSearchModal}
                    />
                  </Grid>

                  <PoprchModal
                    cardValue={cardValue}
                    setCardValue={(data) => {
                      setSearchvalue(data);
                      setFormData({ ...formData, employeeId: data?.id });
                      setCardValue(data);
                    }}
                    callback={() => {}}
                    searchModal={searchModal}
                    setSearchModal={setSearchModal}
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Specialization:"
                      name="specialization"
                      value={formData?.specialization}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          specialization: e.target.value,
                        });
                      }}
                      multiline
                      rows={5}
                      // required
                      InputLabelProps={{ className: "mulish" }}
                      InputProps={{ classes: { input: "mulish" } }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Skills Set:"
                      name="skillSet"
                      value={formData?.skillSet}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          skillSet: e.target.value,
                        });
                      }}
                      // required
                      multiline
                      rows={5}
                      InputLabelProps={{ className: "mulish" }}
                      InputProps={{ classes: { input: "mulish" } }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Achievements:"
                      name="achievements"
                      value={formData?.achievements}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          achievements: e.target.value,
                        });
                      }}
                      // required
                      multiline
                      rows={5}
                      InputLabelProps={{ className: "mulish" }}
                      InputProps={{ classes: { input: "mulish" } }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Overview:"
                      name="overview"
                      value={formData?.overview}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          overview: e.target.value,
                        });
                      }}
                      // required
                      multiline
                      rows={5}
                      InputLabelProps={{ className: "mulish" }}
                      InputProps={{ classes: { input: "mulish" } }}
                    />
                  </FormControl>
                </Grid>
              </React.Fragment>

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "start" }}
              >
                <ImageUploader
                  Clickable={Button}
                  path={formData?.logoPath}
                  callback={(file) => {
                    setFormData({
                      ...formData,
                      File: file,
                    });
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              sx={{ backgroundColor: "white", marginTop: "10px" }}
            >
              <Grid
                item
                xs={12}
                sx={{
                  borderTop: "2px solid #01008B",
                  paddingY: "0 !important",
                  marginLeft: "15px",
                }}
              ></Grid>
              <Grid item xs={6} sx={{ display: "flex", justifyContent: "end" }}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  sx={{
                    backgroundColor: "#01008B",
                    // padding: "14px",
                    // fontSize: "16px",
                  }}
                >
                  {modalData ? "Save" : "Add"}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  onClick={handlePDFExport}
                  color="primary"
                  sx={{
                    backgroundColor: "#01008B",
                  }}
                >
                  {modalData ? "Save & Share" : "Add"}
                </Button>
              </Grid>

              <Box sx={{ display: "none" }}>
                <SelectedEmpPDFView
                  ref={pdfRef}
                  employee={formData}
                  salonInfo={{
                    name: userDetail?.myBusinessName,
                    address: userDetail?.billerAddress,
                    phone: userDetail?.mobileNumber,
                    email: userDetail?.mailID1 || "Palacethesalon@gmail.com",
                  }}
                />
              </Box>
            </Grid>
          </form>
        </Box>
      </Box>
    </Modal>
  );
}
